export default __webpack_public_path__ + "locales/lo-LA/Settings.json?hash=813fc780d0ee962fc86b2606aab0b007";